import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const Order = Loadable(lazy(() => import("./Order")));
const Orderadd = Loadable(lazy(() => import("./Orderadd")));
const Orderview = Loadable(lazy(() => import("./Orderview")));
const YardWorkOrderRoutes = [
    {
        path: '/yard-work-order',
        element: <Order />,
    },
    {
        path: '/yard-work-order/add',
        element: <Orderadd />,
    },
    {
        path: '/yard-work-order/edit/:orderid',
        element: <Orderadd />,
    },
    {
        path: '/yard-work-order/view/:orderid',
        element: <Orderview />,
    },
    {
        path: '/yard-work-order/view/:userType/:orderid',
        element: <Orderview />,
    }
]

export default YardWorkOrderRoutes
